import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Planning\RemoveAssignedMaterialResourceController::__invoke
* @see app/Http/Controllers/Planning/RemoveAssignedMaterialResourceController.php
* @route '/api/planning/{event}/material-resource/{material_resource}'
*/
const RemoveAssignedMaterialResourceController = (args: { event: string | number | { id: string | number }, material_resource: string | number | { id: string | number } } | [event: string | number | { id: string | number }, material_resource: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: RemoveAssignedMaterialResourceController.url(args, options),
    method: 'delete',
})

RemoveAssignedMaterialResourceController.definition = {
    methods: ["delete"],
    url: '/api/planning/{event}/material-resource/{material_resource}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Planning\RemoveAssignedMaterialResourceController::__invoke
* @see app/Http/Controllers/Planning/RemoveAssignedMaterialResourceController.php
* @route '/api/planning/{event}/material-resource/{material_resource}'
*/
RemoveAssignedMaterialResourceController.url = (args: { event: string | number | { id: string | number }, material_resource: string | number | { id: string | number } } | [event: string | number | { id: string | number }, material_resource: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            event: args[0],
            material_resource: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        event: typeof args.event === 'object'
        ? args.event.id
        : args.event,
        material_resource: typeof args.material_resource === 'object'
        ? args.material_resource.id
        : args.material_resource,
    }

    return RemoveAssignedMaterialResourceController.definition.url
            .replace('{event}', parsedArgs.event.toString())
            .replace('{material_resource}', parsedArgs.material_resource.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Planning\RemoveAssignedMaterialResourceController::__invoke
* @see app/Http/Controllers/Planning/RemoveAssignedMaterialResourceController.php
* @route '/api/planning/{event}/material-resource/{material_resource}'
*/
RemoveAssignedMaterialResourceController.delete = (args: { event: string | number | { id: string | number }, material_resource: string | number | { id: string | number } } | [event: string | number | { id: string | number }, material_resource: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: RemoveAssignedMaterialResourceController.url(args, options),
    method: 'delete',
})

export default RemoveAssignedMaterialResourceController